import { z } from 'zod';
import { ACTIONS, ROLES } from './roles.js';
import type { LobbyView } from './view.js';

/** Messages the client sends over the WebSocket. */
export const ClientMsgSchema = z.discriminatedUnion('t', [
  z.object({ t: z.literal('JOIN'), token: z.string(), instanceId: z.string().min(1).max(128) }),
  z.object({
    t: z.literal('SET_CONFIG'),
    turnTimer: z.number().int().min(0).max(600).optional(),
    reactionTimer: z.number().int().min(0).max(120).optional(),
    themeId: z.string().max(64).optional(),
  }),
  z.object({ t: z.literal('START_GAME') }),
  z.object({
    t: z.literal('DECLARE'),
    action: z.enum(ACTIONS),
    target: z.string().optional(),
  }),
  z.object({
    t: z.literal('REACT'),
    reaction: z.enum(['challenge', 'block', 'pass']),
    blockRole: z.enum(ROLES).optional(),
  }),
  z.object({ t: z.literal('LOSE_CARD'), cardIndex: z.number().int().min(0).max(3) }),
  z.object({ t: z.literal('EXCHANGE_KEEP'), keep: z.array(z.number().int().min(0).max(3)).max(2) }),
  z.object({ t: z.literal('REMATCH') }),
  z.object({ t: z.literal('PING') }),
]);
export type ClientMsg = z.infer<typeof ClientMsgSchema>;

/** Messages the server sends. LobbyView/GameView are already viewer-redacted. */
export type ServerMsg =
  | { t: 'HELLO'; you: string; lobby: LobbyView }
  | { t: 'LOBBY'; lobby: LobbyView }
  | { t: 'ERROR'; code: string; message: string }
  | { t: 'PONG' };

export interface TokenResponse {
  sessionToken: string;
  user: { id: string; name: string; avatarUrl?: string };
  /** Raw Discord access token, echoed back for the SDK's authenticate() call. */
  discordAccessToken?: string;
}
